<template>
	<div>
		<import import-url="/api/attributes/import" template-url="/admin/attributes/export" button-text="Download Current Attributes"></import>
	</div>
</template>

<script>
import Import from "@components/partials/Import";

export default {
	components: {
		Import
	},
};
</script>
